import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import { useTheme } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
//import Select from "@material-ui/core/Select";
import Card from "@material-ui/core/Card";
//import MenuItem from "@material-ui/core/MenuItem";
import CardContent from "@material-ui/core/CardContent";
//import CardMedia from "@material-ui/core/CardMedia";
import Grid from "@material-ui/core/Grid";

//import KeyboardArrowDown from "@material-ui/icons/KeyboardArrowDown";

import { Button, Typography } from "@material-ui/core";
// core components
//import AuthHeader from "components/Headers/AuthHeader.js";
//import componentStyles from "assets/theme/views/auth/register.js";
import componentStylesButtons from "assets/theme/components/button.js";

const useStyles = makeStyles((theme) => ({
  cardRoot: {
    // Add animation styles
    animation: `$sideUp 0.5s ease-out`,
    transform: "translateY(100%)",
    opacity: 0,
    animationFillMode: "forwards",
  },
  "@keyframes sideUp": {
    "0%": {
      transform: "translateY(100%)",
      opacity: 0,
    },
    "100%": {
      transform: "translateY(0)",
      opacity: 1,
    },
  },
  cardHeader: {
    textAlign: "center",
  },
  cardContent: {
    textAlign: "center",
  },
  buttonContainedInfo: {
    backgroundColor: theme.palette.info.main,
  },
}));

const useStylesButtons = makeStyles(componentStylesButtons);

function AddContent() {
  const classes = { ...useStyles(), ...useStylesButtons() };
  const theme = useTheme();
  const history = useHistory();
  const [cards, setcards] = useState([]);
  const location = useLocation(); // Use useLocation to access the state
  const { course_id, batch_id } = location.state || {}; // Access the state or provide a default value
  const [privilege, setprivilege] = useState("");

  const [alertText, setalertText] = useState("");
  const [form, setform] = useState({
    title: "",
    description: "",
    link: "",
  });

  const VideoCard = ({ title, videoUrl, description }) => (
    <Grid item xs={12} sm={6} md={4} lg={3}>
      <Card>
        <CardContent>
          <Box sx={{ height: "1000px", width: "100%" }}>
            <iframe
              src={videoUrl}
              title="YouTube video"
              style={{
                height: "100%",
                width: "100%",
                border: "none",
              }}
              allowFullScreen
            />
          </Box>
          <Typography
            gutterBottom
            variant="h5"
            component="div"
            style={{ marginTop: "10%", fontWeight: "bold", fontSize: "16px" }}
          >
            {title}
          </Typography>

          <Typography gutterBottom variant="h5" component="div">
            {description}
          </Typography>

          {privilege === "admin" || privilege === "teacher" ? (
            <Button onClick={() => deleteVideo(videoUrl)} style={{ backgroundColor: "red", color: "white" }}>
              Delete
            </Button>
          ) : null}
        </CardContent>
      </Card>
    </Grid>
  );


  
  const deleteVideo = (url) => {
    var token = localStorage.getItem("token");
   
    const fetchData = async () => {
    
      try {
        const res = await fetch("https://server.thelanofficial.com/Delete-UploadedVideo", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ token:token , URL: url }),
        });
  
        if (!res.ok) {
          throw new Error("Network response was not ok");
        }
  
        const data = await res.json();
        if (data.deleted === true) {
           alert("Video deleted")
           history.push("/admin/All-Courses");
        }
      } catch (error) {
        console.error("There was a problem with the fetch operation:", error);
      }
    };

    fetchData()


  }


  useEffect(() => {
    var token = localStorage.getItem("token");


    const fetchPrivilege = async (token) => {
      try {
        const response = await fetch('https://server.thelanofficial.com/privilege', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ token }),
        });
    
        const data = await response.json();
    
        if (data.valid) {
         
          // You can now use data.privilege for any conditional rendering or logic
        
          setprivilege(data.privilege)
        } else {
          console.log('Invalid token');
        }
      } catch (error) {
        console.error('Error fetching privilege:', error);
      }
    };
    

    const fetchData = async () => {
      try {
        const res = await fetch(
          "https://server.thelanofficial.com/validate-token",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({ token, course_id }),
          }
        );

        if (!res.ok) {
          throw new Error("Network response was not ok");
        }

        const data = await res.json();
        if (data.valid === false) {
          history.push("/auth/login");
        }
      } catch (error) {
        console.error("There was a problem with the fetch operation:", error);
      }
    };

    const fetchContent = async () => {
      try {
        const response = await fetch(
          "https://server.thelanofficial.com/Get-Content",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ token, course_id: course_id }),
          }
        );

        const data = await response.json();

        if (!data.valid) {
          console.error(data.message);
        } else {
          setcards(data.result);
        }
      } catch (err) {
        console.error("Error fetching content:", err);
      }
    };

    fetchData();

    fetchContent();

    fetchPrivilege(token);
  }, []);

  const videoUrl = "https://www.youtube.com/embed/IWHzrupqlGM";

  return (
    <>
      <Box sx={{ flexGrow: 1, padding: 2 }}>
        <Grid container spacing={2}>
          <Typography></Typography>
          {cards.map((card, index) => (
            <VideoCard
              key={index}
              title={card.title}
              videoUrl={card.videoUrl}
              description={card.description}
            />
          ))}
        </Grid>
      </Box>
    </>
  );
}

export default AddContent;
